import { stepUpSeconds } from "@estate-platform/domain/vault-timing";
import { locales } from "@estate-platform/i18n/runtime";
import { z } from "zod";

import type { Locale } from "@estate-platform/i18n/runtime";

const stepUpWindow = stepUpSeconds * 1000;
const checkMethods = new Set(["passkey", "totp"]);

const amrEntrySchema = z.object({ method: z.string(), timestamp: z.number() });

const claimsSchema = z.object({
  session_id: z.uuid(),
  aal: z.string(),
  amr: z.array(amrEntrySchema).default([]),
  user_metadata: z
    .object({ language: z.enum(locales).optional().catch(undefined) })
    .optional()
    .catch(undefined),
});

export interface SessionClaims {
  readonly sessionId: string;
  readonly isComplete: boolean;
  readonly verifiedUntil: number | null;
  readonly language: Locale | null;
}

export const readClaims = (claims: unknown): SessionClaims => {
  const parsed = claimsSchema.parse(claims);
  const checks = parsed.amr.filter((entry) => checkMethods.has(entry.method)).map((entry) => entry.timestamp);
  return {
    sessionId: parsed.session_id,
    isComplete: parsed.aal === "aal2" || parsed.amr.some((entry) => entry.method === "passkey"),
    verifiedUntil: checks.length === 0 ? null : Math.max(...checks) * 1000 + stepUpWindow,
    language: parsed.user_metadata?.language ?? null,
  };
};
